import * as Yup from "yup";

export const validationSchema = Yup.object({
  temp_token: Yup.lazy((value) => {
    if (value !== undefined) {
      return Yup.string().required("شماره ارسال شده را وارد کنید");
    }

    return Yup.string().required("شماره ارسال شده را وارد کنید");
  }),
});

export const initialValue = {
  temp_token: "",
};
